import { render, staticRenderFns } from "./DxBareRootsContentForm.vue?vue&type=template&id=275956e6&scoped=true&"
import script from "./DxBareRootsContentForm.vue?vue&type=script&lang=js&"
export * from "./DxBareRootsContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275956e6",
  null
  
)

export default component.exports